const prefix = 'MERCHANT';

export const POST_CONTACT_US = `${prefix}/POST_CONTACT_US`;
